import * as React from 'react';

export class Error extends React.Component {
  public render() {
    return (
      <div className="error container">
        <h1>Thank you</h1>
        <p>
          Thank you for your flexibility and interest. However, volunteers are no longer needed for this flight.
          Please continue as normal for your scheduled flight.
        </p>
        <p className="small">
          <a target="_blank" href="https://www.alaskaair.com/">Visit alaskaair.com</a>
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/error.tsx